import { useRef, useMemo } from "react";
import { RecommendedCard } from "@/components/shared/recommended-card";
import { ListHeading } from "@/components/shared/list-header";
import { recommendedServiceItems } from "@/containers/homepage/lib";
import { HorizontalScroll } from "../horizontal-scroll";
import type { HorizontalScrollRef } from "../horizontal-scroll/lib";
import { View } from "@/components/ui";
import { IconButton } from "@/components/ui/icon-button";
import type { Icon } from "@/components/shared/icons";
import { ThumbsUp } from "@/components/shared/icons";

export function RecommendedServices({
  title,
  icon,
}: {
  title?: string;
  icon?: Icon;
}) {
  const shuffledCards = useMemo(
    () => [...recommendedServiceItems].sort(() => Math.random() - 0.5),
    [],
  );
  const scrollRef = useRef<HorizontalScrollRef>(null);
  return (
    <View className="flex flex-col gap-2">
      <View className="flex flex-row justify-between gap-2">
        <ListHeading
          title={title || "Maybe you’ll like it."}
          icon={icon || ThumbsUp}
        />
        <View className="native:hidden flex flex-row items-center gap-2">
          <IconButton
            variant="secondary"
            color="foreground"
            rounded="full"
            size="sm"
            iconName="caretLeft"
            onClick={() => scrollRef.current?.prev()}
            className="h-7 w-7 border border-input bg-background"
          />
          <IconButton
            variant="secondary"
            color="foreground"
            rounded="full"
            size="sm"
            iconName="caretRight"
            onClick={() => scrollRef.current?.next()}
            className="h-7 w-7 border border-input bg-background"
          />
        </View>
      </View>
      <HorizontalScroll
        ref={scrollRef}
        data={shuffledCards}
        itemSpacing={16}
        itemWidth={144}
        snap="start"
        renderItem={(item) => <RecommendedCard {...item} />}
      />
    </View>
  );
}
